import styles from './styles.module.scss'
import { InboxCard } from 'widgets/inbox/InboxCard'
import { ConversationList } from 'widgets/inbox/ConversationList'
import { ConversationChat } from 'widgets/inbox/ConversationChat'
import { useSearchParams } from 'react-router-dom'
import { NewConversationChat } from 'widgets/inbox/NewConversationChat'
import { ContainerHeader } from 'shared/ui/Header'

export const InboxId = () => {
  const [params] = useSearchParams()
  return (
    <div className={styles.wrap}>
      <div className={styles.left}>
        <ContainerHeader>
          <InboxCard />
        </ContainerHeader>

        <ConversationList />
      </div>
      <div className={styles.center}>
        {params.has('new') ? <NewConversationChat /> : <ConversationChat />}
      </div>
      <div className={styles.right}></div>
    </div>
  )
}
